import { computed, effect, inject, Injectable, signal } from '@angular/core';

import { AttributeInformationService } from '@connect-services/client/services/attribute-information.service';
import { ProjectEntityTableService } from '@connect-services/client/services/project-entity-table.service';
import { InformationSchemaTableExtended } from '@connect-services/src/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class AttributeInformationContextService {
    public readonly activeLayerId = computed<string | undefined>(() => {
        if (!this.projectEntityTableService.activeLayers()?.length) {
            return undefined;
        }

        return this.projectEntityTableService.activeLayers()[0].id;
    });
    public readonly attributeInformationList = signal<InformationSchemaTableExtended[]>([]);
    public readonly businessIdentifierKey = computed<string>(() => {
        if (!this.projectEntityTableService.activeLayers()?.length) {
            return 'uuid';
        }

        return this.projectEntityTableService.activeLayers()[0].businessIdentifier ?? 'uuid';
    });

    private readonly attributeInformationService = inject(AttributeInformationService);
    private readonly projectEntityTableService = inject(ProjectEntityTableService);

    public constructor() {
        effect(async () => {
            if (!this.activeLayerId()) {
                this.attributeInformationList.set([]);

                return;
            }

            const infos = await this.attributeInformationService.loadForLayer(this.activeLayerId()!);
            this.attributeInformationList.set(infos);
        });
    }

    public getAttributeInformation(columnKey: string): InformationSchemaTableExtended | null {
        if (!this.attributeInformationList().length) {
            return null;
        }

        return this.attributeInformationService.findByKey(this.attributeInformationList(), columnKey);
    }
}
